import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SelectTrigger } from "@activecollab/components";
import PropTypes from "prop-types";
import { TemplateTaskPanelDueOnForm } from "./TemplateTaskPanelDueOnForm";
import { TemplateTaskPanelItem } from "./TemplateTaskPanelItem";

export const TemplateTaskDatePicker = ({ task, onChange }) => {
  const { t } = useTranslation();

  const handleChange = (data) => {
    onChange({ start_on: +data.start_in, due_on: +data.due_in });
  };

  const triggerText = useMemo(() => {
    const startOn = +task.start_on;
    const dueOn = +task.due_on;
    if (startOn && dueOn > 0 && startOn !== dueOn) {
      return t("{{startOn}}-{{dueOn}}. day of a project", { startOn, dueOn });
    }

    if (dueOn > 0) {
      return t("{{dueOn}}. day of a project", { dueOn });
    }

    return t("Set...");
  }, [t, task.due_on, task.start_on]);

  const trigger = useMemo(() => {
    return (
      <SelectTrigger
        data-testid="trigger-text"
        typographyProps={{
          color: task.due_on || task.start_on ? "primary" : "quaternary",
        }}
      >
        {triggerText}
      </SelectTrigger>
    );
  }, [task.due_on, task.start_on, triggerText]);

  return (
    <TemplateTaskPanelItem label={t("Due On")}>
      <TemplateTaskPanelDueOnForm
        startOn={task.start_on === "" ? null : task.start_on}
        dueOn={task.due_on === "" ? null : task.due_on}
        onChange={handleChange}
        trigger={trigger}
        targetClassName="tw-w-full"
      />
    </TemplateTaskPanelItem>
  );
};

TemplateTaskDatePicker.propTypes = {
  task: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
